import React from "react";
import * as S from "./styled";
import PT from "prop-types";
import { useMut } from "@/hooks/useMut";
import { Button } from "_c/button";

const TrialActivation = (props) => {
  const mut = useMut(props.activateTrial, {
    t: props.t,
    notifyOnError: true,
  });
  return (
    <S.Wrap>
      <p>{props.t("premium:advice")}</p>
      <Button
        disabled={mut.isLoading}
        onClick={mut.mutate}
        type="button"
        greenish
        medium
      >
        {props.t("premium:activate")}
      </Button>
    </S.Wrap>
  );
};

TrialActivation.propTypes = {
  activateTrial: PT.func.isRequired,
  t: PT.func.isRequired,
};

export default TrialActivation;
